<div class="contentHeight container-fluid">
  <h1 class="text-center containerTitle">Historique des activations balance</h1>
  <div class="row noMargin">
    <div class="col-12">
      <div class="text-right mb-1">
        <i aria-hidden="true" (click)="refresh()" class="fal fa-sync fa-lg p-2 pointer"></i>
      </div>
    </div>
  </div>
  <div class="row mx-auto adminContent">
    <div class="col-xl-11 col-lg-11 col-md-12 mx-auto">
      <mat-form-field class="ml-2">
        <mat-label>Rechercher</mat-label>
        <input matInput (keyup)="applyFilter($event.target.value)">
      </mat-form-field>
      <div class="table-wrapper-scroll-y noOverflow">
        <mat-table class="table bg-white respTab table-hover" [dataSource]="historySource" matSort (matSortChange)="sortScale($event,'1')">
          <!--scaleHistoryID-->
          <ng-container matColumnDef="scaleHistoryID">
            <mat-header-cell *matHeaderCellDef mat-sort-header>N°</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.scaleHistoryID}}</mat-cell>
          </ng-container>
          <!--date-->
          <ng-container matColumnDef="orderDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.orderDate | date:'dd/MM/yyyy HH:mm'}}</mat-cell>
          </ng-container>
          <!--scaleID-->
          <ng-container matColumnDef="scaleID">
            <mat-header-cell *matHeaderCellDef mat-sort-header>scaleID</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.scaleID}}</mat-cell>
          </ng-container>
          <!--code-->
          <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef mat-sort-header>N° de balance</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.code}}</mat-cell>
          </ng-container>
          <!--serialNumber-->
          <ng-container matColumnDef="serialNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>N° de série</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.serialNumber}}</mat-cell>
          </ng-container>
          <!--activationID-->
          <ng-container matColumnDef="activationID">
            <mat-header-cell *matHeaderCellDef mat-sort-header>N° de dossier</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.activationID}}</mat-cell>
          </ng-container>
          <!--licenceStart-->
          <ng-container matColumnDef="licenceStartDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date d'activation</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.licenceStartDate | date:'dd/MM/yyyy'}}</mat-cell>
          </ng-container>
          <!--licenceEnd-->
          <ng-container matColumnDef="licenceEndDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date d'expiration</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.licenceEndDate | date:'dd/MM/yyyy'}}</mat-cell>
          </ng-container>
          <!--activationCode-->
          <ng-container matColumnDef="activationCode">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Code d'activation</mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.activationCode}}</mat-cell>
          </ng-container>        
          <!--Ancienne balance-->
          <ng-container matColumnDef="oldScale">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Ancienne balance (si échange)</mat-header-cell>
            <mat-cell *matCellDef="let res">
              <span *ngIf="res.oldScaleID != 0">{{res.oldScaleCode}} / {{res.oldScaleSerialNumber}}</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    </div>

  </div>
</div>


